import { useOperators } from "../../hooks/useOperators";
import { usePersons } from "../../hooks/usePersons";
import { OperatorFeatures } from "../../urls";

function useMenuPermissions({ variantId }: { variantId?: number }) {
  const { paragraph6Persons, isLoading: isLoadingPersons } = usePersons({
    variantId
  });

  const { data: revenueMonitoringOperators } = useOperators({
    activeFeatures: [OperatorFeatures.RevenueMonitoring]
  });

  const paragraph6Enabled = paragraph6Persons && paragraph6Persons.length > 0;
  const revenueMonitoringEnabled =
    revenueMonitoringOperators && revenueMonitoringOperators.length > 0;

  return {
    paragraph6Enabled,
    revenueMonitoringEnabled,
    isLoadingParagraph6: isLoadingPersons
  };
}

export { useMenuPermissions };
